import React from 'react';

import { SVGComponentProps } from './svg.types';

const SortSVG = ({ size = '1em', fill = 'currentColor', ...otherSvgProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <g clipPath="url(#clip0_2528_15555)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.77043 4.38586L4.72661 2.40522L4.69842 8.31564C4.69807 8.40608 4.6791 8.49557 4.64259 8.57898C4.60609 8.66239 4.55277 8.73809 4.48569 8.80174C4.41861 8.86539 4.33908 8.91575 4.25166 8.94993C4.16423 8.98411 4.07063 9.00144 3.9762 9.00093C3.88183 9.00051 3.78847 8.98228 3.70146 8.94728C3.61445 8.91228 3.53549 8.8612 3.46911 8.79696C3.40272 8.73272 3.3502 8.65658 3.31456 8.57289C3.27891 8.4892 3.26084 8.3996 3.26137 8.30922L3.28889 2.40007L1.22426 4.35436C1.1573 4.41806 1.07788 4.46849 0.990557 4.50277C0.90323 4.53705 0.809704 4.55451 0.715327 4.55416C0.620949 4.5538 0.527572 4.53563 0.440531 4.50068C0.353491 4.46574 0.274495 4.4147 0.20806 4.3505C0.0739561 4.22069 -0.000872564 4.04522 8.15229e-06 3.86261C0.000888868 3.68 0.0774074 3.50519 0.212758 3.37657L3.60167 0.162287C3.7132 0.0571821 3.86375 -0.00118722 4.02021 1.83581e-05C4.17667 0.00122393 4.32623 0.0619057 4.43598 0.168716L7.792 3.41707C7.92606 3.54677 8.00087 3.72214 7.99999 3.90465C7.99911 4.08715 7.92261 4.26185 7.7873 4.39036C7.72023 4.45403 7.64073 4.50443 7.55332 4.53867C7.46591 4.5729 7.37232 4.59031 7.27789 4.58989C7.18346 4.58947 7.09004 4.57124 7.00296 4.53623C6.91589 4.50122 6.83687 4.45012 6.77043 4.38586Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.22957 9.61512L9.27339 11.5958L9.30158 5.68533C9.30193 5.59489 9.3209 5.50541 9.35741 5.422C9.39391 5.33859 9.44722 5.26289 9.51431 5.19924C9.58139 5.13559 9.66092 5.08523 9.74834 5.05105C9.83577 5.01687 9.92937 4.99954 10.0238 5.00005C10.1182 5.00047 10.2115 5.0187 10.2985 5.0537C10.3855 5.08869 10.4645 5.13977 10.5309 5.20401C10.5973 5.26825 10.6498 5.3444 10.6854 5.42809C10.7211 5.51178 10.7392 5.60138 10.7386 5.69176L10.7111 11.6009L12.7757 9.64662C12.8427 9.58292 12.9221 9.53249 13.0094 9.49821C13.0968 9.46392 13.1903 9.44646 13.2847 9.44682C13.3791 9.44718 13.4724 9.46535 13.5595 9.50029C13.6465 9.53524 13.7255 9.58627 13.7919 9.65048C13.926 9.78028 14.0009 9.95576 14 10.1384C13.9991 10.321 13.9226 10.4958 13.7872 10.6244L10.3983 13.8387C10.2868 13.9438 10.1362 14.0022 9.97979 14.001C9.82333 13.9998 9.67377 13.9391 9.56402 13.8323L6.208 10.5839C6.07394 10.4542 5.99913 10.2788 6.00001 10.0963C6.00089 9.91383 6.07739 9.73912 6.2127 9.61062C6.27977 9.54694 6.35927 9.49655 6.44668 9.46231C6.53409 9.42807 6.62768 9.41067 6.72211 9.41109C6.81654 9.4115 6.90996 9.42974 6.99704 9.46475C7.08411 9.49976 7.16313 9.55085 7.22957 9.61512Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2528_15555">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SortSVG;
